import { Button, ButtonProps } from '@chakra-ui/button';
import React, { FC } from 'react';
import { FaCheck } from 'react-icons/fa';
import { cx } from '@chakra-ui/shared-utils';

export interface VoteButtonProps extends ButtonProps {
  isSelected: boolean;
}
export const VoteButton: FC<VoteButtonProps> = ({ isSelected, children, ...buttonProps }) => {
  const selectedStyles = {
    bg: 'VoteButton-bg-selected',
  };
  const ButtonContent = () => {
    if (!isSelected) return <>{children}</>;

    return <FaCheck />;
  };

  const isSubmitted = isSelected && buttonProps.isDisabled;

  return (
    <Button
      sx={{ '& svg': { display: 'inline-block', verticalAlign: 'middle', fontSize: '1.4em' } }}
      color={isSubmitted ? 'VoteButton-text-submitted' : 'VoteButton-text'}
      bg={isSubmitted ? 'VoteButton-bg-submitted' : 'VoteButton-bg'}
      fontSize="sm"
      textAlign={'center'}
      _disabled={{
        bg: isSubmitted ? 'VoteButton-bg-submitted' : 'VoteButton-bg',
        opacity: isSubmitted ? 1 : 0.6,
        boxShadow: 'none',
        pointerEvents: 'none',
      }}
      _hover={{ bg: 'VoteButton-bg-hover', color: 'VoteButton-text-hover' }}
      _active={{ bg: 'VoteButton-bg-active', color: 'VoteButton-text-active' }}
      {...buttonProps}
      {...(isSelected && { ...selectedStyles })}
      className={cx('VoteButton', buttonProps.className)}>
      <ButtonContent />
    </Button>
  );
};
